
<ng-template ngFor let-item [ngForOf]="validationErrorRows" let-isLast="last">{{ item.processed }}
  <ng-template [ngIf]="!isLast"><br></ng-template>
</ng-template>